import { render, staticRenderFns } from "./ProductDimensionsHeight.vue?vue&type=template&id=39e24e0a&"
import script from "./ProductDimensionsHeight.vue?vue&type=script&lang=ts&"
export * from "./ProductDimensionsHeight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports